import React, { useEffect, useState } from "react";
import * as S from "./ContentManagement";
import ToolbarContentManagement from "./components/toolbarContentManagement";
import ContentCard from "./components/contentCard";
import FlorenzButton from "../../florenzComponents/florenzButton";
import Modal from "../../../utils/modal";
import ModalAddOutcomesEvent from "../shared/modals/modalAddOutcomesEvent";
import ModalContent from "./components/modalContent";
import { useQuery } from "@apollo/client";
import { QUERY_GET_CONTENT_INFO } from "../../../graphql/queries/Content";
import * as P from "../../../utils/pipes";
import { useTranslation } from "react-i18next";


function ContentManagement () {

  const {t, i18n: { language }} = useTranslation("global");

  const [inputText, setInputText] = useState(null);
  const [contentSelected, setContentSelected] = useState();

  const {data: contentInfo, loading: contentInfoLoading, error: contentInfoError} = useQuery(QUERY_GET_CONTENT_INFO);     
  
  const getFilterText = (text) => {
    
    return inputText 
      ? String(text).toLowerCase().includes(inputText.toLowerCase())
      : true
  }

  return (
    <S.ContentManagement>
      {
        <Modal open={contentSelected}>
          <ModalContent
            content={contentSelected}
            setContentSelected={setContentSelected}
          />
        </Modal>
      }
      <div className="content-management-toolbar">
        <div className="label">
          {t("globally.managementContent")}
        </div>
        <div className="toolbar-container">
          <ToolbarContentManagement 
            setInputText={setInputText}
          />
        </div>
      </div>
      <div className="content-management-list">
        {
          contentInfo?.mediaGroup.map((item, index) => (
            (
              getFilterText(P.dataTranslation(item.name, language)) || 
              getFilterText(P.dataTranslation(item.description, language))
            ) &&
            <ContentCard
              selectContent={setContentSelected}
              item={item}
              key={index}
              setInputText={setInputText}
            />
          ))
        }
      </div>
    </S.ContentManagement>
  )

}

export default ContentManagement;
